import MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry from "../../../sections/DirectiveEntry/entries/DiagnosticEntry";

const DiagnosticEntryCanceled = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry />
    </>
  );
}

export default DiagnosticEntryCanceled;
